import RefreshIcon from "@mui/icons-material/Refresh"
import { Box, IconButton, Tooltip } from "@mui/material"

/** Table refresh only; retry and delivery-result actions keep their own labels. */
export function RefreshTableButton({
  label,
  disabled,
  onClick,
}: {
  label: string
  disabled?: boolean
  onClick: () => void
}) {
  return (
    <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
      <Tooltip title={label} disableInteractive>
        <span>
          <IconButton
            size="small"
            aria-label={label}
            disabled={disabled}
            onClick={onClick}
          >
            <RefreshIcon fontSize="small" />
          </IconButton>
        </span>
      </Tooltip>
    </Box>
  )
}
